import React, { Component, Fragment } from "react";
import { withRouter , Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch"
import { getMessagemErro } from "../../utils/erro";
import { ID_SITUACAO_SOLICITACAO_REJEITADA_CEDENTE, ID_SITUACAO_SOLICITACAO_REJEITADA_GESTOR_PLATAFORMA } from "../../providers/constSituacoesSolicitacao";
import api from "../../services/api";
import { isIP } from 'is-ip';
import './SolicitacaoAdesaoArquivosGrandesVoumes.css';
import { SolicitacaoAdesaoAttachmentsAndHistory } from "./AttachmentsAndHistory";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft, faCirclePlus, faCircleMinus } from "@fortawesome/free-solid-svg-icons";
import { FinalidadeSolicitacaoAdesao } from "../FinalidadeSolicitacaoAdesao/FinalidadeSolicitacaoAdesao";
import { SecureDirectoryClientInformation } from "../SecureDirectory/SecureDirectoryClientInformation";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

export const SolicitacaoAdesaoArquivosGrandesVolumesEdit =

withRouter(

// redux
connect(
	(null), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				solicitacao: {
					id: '',
					numero: '',
					orgao: '',
					conjuntoArquivo: '',
					tituloConjuntoArquivo: '',
					descricaoConjuntoArquivo: '',
					arquivos: [],
					situacao: '',
					nomeSituacao: '',
					cpfDirigenteTi: '',
					cpfResponsavelTecnico: '',
					finalidade: '',
					orgaoPossuiPastaSeguraConfigurada: false,
					ipsInternet: '',
					so: '',
					alteracaoPermitida: true,
				},
				orgaos: [],
				orgao: '',
				conjuntosArquivos: [],
				arquivosDisponivesAdesao: [],
				arquivosOrgao: [],
				dirigentesTi: [],
				responsaveisTecnicos: [],
				textoPadraoFinalidade: '',
				carregandoOrgaosFornecedores: false,
				carregandoConjuntosArquivos: false,
				carregandoDirigentesTi: false,
				carregandoResponsaveisTecnicos: false,
				carregandoDetalhesConjuntoArquivos: false,
				carregandoArquivos: false,
				exibeModalModeloFinalidade: false,
				exibeModalInstrucao: false,
				exibeModalConfirmacao : false,
				msgModal: '',
				botoesHabilitados : true,
				dataHoraCarregamentoPagina: new Date(),
				keyFinalidade: new Date(),
			};
			
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleOrgaoChange = this.handleOrgaoChange.bind(this);
			this.handleConjuntoArquivoChange = this.handleConjuntoArquivoChange.bind(this);
			this.carregaOrgaosFornecedoresArquivosGV = this.carregaOrgaosFornecedoresArquivosGV.bind(this);
			this.carregarConjuntosArquivosDisponiveisAdesao = this.carregarConjuntosArquivosDisponiveisAdesao.bind(this);
			this.carregarDirigentesTi = this.carregarDirigentesTi.bind(this);
			this.carregarResponsaveisTecnicos = this.carregarResponsaveisTecnicos.bind(this);
			this.carregarInformacoesConjuntoArquivos = this.carregarInformacoesConjuntoArquivos.bind(this);
			this.carregarArquivos = this.carregarArquivos.bind(this);
			this.confirmaOperacao = this.confirmaOperacao.bind(this);
			this.executaOperacao = this.executaOperacao.bind(this);
			this.salvar = this.salvar.bind(this);
			this.novo = this.novo.bind(this);
			this.onChangePropertiesFinalidade = this.onChangePropertiesFinalidade.bind(this);
			this.onChangePropertiesSecureDirectoryClientInformation = this.onChangePropertiesSecureDirectoryClientInformation.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Solicitação de Adesão a Arquivos de Grandes Volumes</h1>
					</div>
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;

			if(id){
				api.get(`/api/solicitacao-adesao-arquivo-gv/${id}`)
					.then(response => { 
						const solicitacao = response.data;
						this.setState({ solicitacao }) ;

						this.carregarInformacoesConjuntoArquivos(solicitacao.conjuntoArquivo);
						this.carregarDirigentesTi();
						this.carregarResponsaveisTecnicos();
						this.carregarArquivos(solicitacao.conjuntoArquivo);
					})
					.catch(erro => {
						const msg = getMessagemErro("Não foi possível recuperar a solicitação de adesão.", erro);
						console.log(JSON.stringify(msg));
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					});
			} else {
				this.carregaOrgaosFornecedoresArquivosGV();
				this.carregarConjuntosArquivosDisponiveisAdesao();
				this.carregarDirigentesTi();
				this.carregarResponsaveisTecnicos();

				const { search } = this.props.location;
				const params = new URLSearchParams(search);
				const conjuntoArquivo = params.get('conjuntoArquivo');
				if(conjuntoArquivo){
					const solicitacao = this.state.solicitacao;
					solicitacao.conjuntoArquivo = Number(conjuntoArquivo);
					this.setState({ solicitacao });
					this.carregarInformacoesConjuntoArquivos(conjuntoArquivo);
					this.carregarArquivos(conjuntoArquivo);
				}
			}
		}

		renderForm() {
			const { solicitacao, arquivosDisponivesAdesao, keyFinalidade } = this.state;

			return(
				<div className="container-fluid">

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalConfirmacao}
						handleOk={() => this.executaOperacao()}
						handleCancel={() => this.setState({exibeModalConfirmacao: false})}
						message={this.state.msgModal}/>

					<div className="br-form">
						{ solicitacao.id &&
							<div className="row">
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Número:</label>
											<input value={solicitacao.numero} readOnly/>
										</div>
									</div>
								</div>
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Situação:</label>
											<input value={solicitacao.nomeSituacao} readOnly/>
										</div>
									</div>
								</div>
							</div>
						}
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Cedente dos dados:</label>
										{solicitacao.id &&
											<input value={solicitacao.nomeOrgaoConjuntoArquivo} className="input-bold" readOnly/>
										}
										{!solicitacao.id &&
											<>
											{this.state.orgaos.length > 0 && 
												<SelectSearch
													id="orgao"
													name="orgao"
													options={this.state.orgaos.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
													onChange={this.handleOrgaoChange}
													value={this.state.orgao}
												/>
											}
											{ this.state.carregandoOrgaosFornecedores === true  && 
												<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
											{(this.state.carregandoOrgaosFornecedores === false && this.state.orgaos.length === 0) && "Não há órgãos cedentes de arquivos de grandes volumes."}
										</>
										}
									</div>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Conjunto de Arquivos:</label>
										{solicitacao.id &&
											<input value={solicitacao.tituloConjuntoArquivo} className="input-bold" readOnly/>
										}
										{!solicitacao.id &&
											<>
												{this.state.conjuntosArquivos.length > 0 && 
													<SelectSearch
														id="conjuntoArquivo"
														name="conjuntoArquivo"
														options={this.state.conjuntosArquivos.map(conjunto => ({ value: conjunto.id, label: conjunto.titulo + " (" + conjunto.nomeOrgao + ")" }) )}
														onChange={this.handleConjuntoArquivoChange}
														value={solicitacao.conjuntoArquivo}
														disabled={solicitacao.id}
													/>
												}
												{ this.state.carregandoConjuntosArquivos === true  && 
													<button className="br-button is-secondary is-circle is-loading" type="button"/>
												}
												{this.state.carregandoConjuntosArquivos === false && this.state.conjuntosArquivos.length === 0 && "Não há conjuntos de arquivos disponíveis para adesão."}
											</>
										}
									</div>
								</div>
							</div>
						</div>

						{solicitacao.conjuntoArquivo &&	
							<Fragment>
								<div className="row">
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Descrição:</label>
												<textarea value={solicitacao.descricaoConjuntoArquivo} className="input-bold" readOnly style={{height:"90px"}}/>
												{ this.state.carregandoDetalhesConjuntoArquivos === true  && 
													<button className="br-button is-secondary is-circle is-loading" type="button"/>
												}
											</div>
										</div>
									</div>
								</div>
							
								{(arquivosDisponivesAdesao.length > 0) &&	
									<Fragment>
										<div className="row">
											<div className="col-md">
												<div className="field">
													<div className="input">
														<label>Arquivos:</label>

														<div className="br-table">						
															<div className="table">
																<table>
																	<thead>
																		<tr>
																			<th scope="col">Nome</th>
																			<th scope="col">Descrição</th>
																			<th scope="col">Formato</th>
																			<th scope="col" className="text-right">Tamanho em MB</th>
																			<th scope="col">Periodicidade</th>
																			<th className="text-center" scope="col">Ações</th>
																		</tr>
																	</thead>
																	
																	<tbody>
																		{ arquivosDisponivesAdesao.map((arquivo, index) =>
																				<tr key={index} className={arquivo.orgaoPossuiAdesaoArquivo ? "tr-bold" : ""}>
																					<td style={{width: "20%"}}>{arquivo.nome}</td>
																					<td>{arquivo.descricao}</td>
																					<td style={{width: "10%"}}>{arquivo.nomeExtensaoArquivo}</td>
																					<td style={{width: "10%"}} className="text-right">{arquivo.tamanho}</td>
																					<td style={{width: "10%"}}>{arquivo.nomePeriodicidade}</td>
																					<td style={{width: "5%"}} className="text-center">
																						<div className="actions">
																							{ ! arquivo.orgaoPossuiAdesaoArquivo &&
																								<>
																									{!arquivo.inclusao &&
																										<button type="button" onClick={() => this.adicionarAdesao(arquivo)} title="Adicionar adesão para o arquivo">
																											<span className="sr-only">Adicionar adesão</span>
																											<FontAwesomeIcon icon={faCirclePlus} style={{color: "#449D44"}} />
																										</button>
																									}		

																									{arquivo.inclusao &&
																										<button type="button" onClick={() => this.desfazerAdesao(arquivo)} title="Desfazer adesão para o arquivo">
																											<span className="sr-only">Desfazer adesão</span>
																											<FontAwesomeIcon icon={faRotateLeft} style={{color: "#1351b4"}} />
																										</button>
																									}						
																									{arquivo.inclusao ? "Adesão" : ""}
																								</>	
																							}

																							{ arquivo.orgaoPossuiAdesaoArquivo &&
																								<>
																									{! arquivo.exclusao &&
																										<button type="button" 
																											onClick={() => this.confirmaOperacao(this.excluirAdesao, [arquivo], `Deseja realmente remover do órgão a adesão ao arquivo ${arquivo.nome}?`)} 
																											title="Excluir adesão para arquivo">
																											<span className="sr-only">Excluir adesão</span>
																											<FontAwesomeIcon icon={faCircleMinus} style={{color: "#C9302C"}} />
																										</button>
																									}

																									{arquivo.exclusao &&
																										<button type="button" onClick={() => this.desfazerExclusao(arquivo)} title="Desfazer exclusão de adesão para o arquivo">
																											<span className="sr-only">Desfazer exclusão da adesão</span>
																											<FontAwesomeIcon icon={faRotateLeft} style={{color: "#1351b4"}} />
																										</button>
																									}		
																									{arquivo.exclusao ? "Exclusão" : ""}
																								</>																							}

																						</div>
																					</td>
																				</tr>
																			)}
																	</tbody>
																</table>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										
									</Fragment>
								}

								<div className="row">
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Dirigente de TI:</label>
												{ this.state.dirigentesTi.length > 0 && 
													<SelectSearch
														id="cpfDirigenteTi"
														name="cpfDirigenteTi"
														options={this.state.dirigentesTi.map(dirigenteTi => ({ value: dirigenteTi.cpf, label: `${dirigenteTi.cpf} - ${dirigenteTi.nome}` }))}
														onChange={this.handleInputChange}
														value={solicitacao.cpfDirigenteTi}
													/>
												}
												{this.state.carregandoDirigentesTi === true && 
													<button className="br-button is-secondary is-circle is-loading" type="button"/>
												}
												{this.state.carregandoDirigentesTi === false && this.state.dirigentesTi.length === 0 && "Não há dirigentes de TI cadastrados no órgão."}
											</div>
										</div>
									</div>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Responsável Técnico:</label>
												{ this.state.responsaveisTecnicos.length > 0 && 
													<SelectSearch
														id="cpfResponsavelTecnico"
														name="cpfResponsavelTecnico"
														options={this.state.responsaveisTecnicos.map(responsavelTecnico => ({ value: responsavelTecnico.cpf, label: `${responsavelTecnico.cpf} - ${responsavelTecnico.nome}` }))}
														onChange={this.handleInputChange}
														value={solicitacao.cpfResponsavelTecnico}	
													/>
												}
												{this.state.carregandoResponsaveisTecnicos === true && 
													<button className="br-button is-secondary is-circle is-loading" type="button"/>
												}
												{this.state.carregandoResponsaveisTecnicos === false && this.state.responsaveisTecnicos.length === 0 && "Não há responsáveis técnicos cadastrados no órgão."}
											</div>
										</div>
									</div>
								</div>

								<FinalidadeSolicitacaoAdesao solicitacao={solicitacao} onChangeProperties={this.onChangePropertiesFinalidade} keyFinalidade={keyFinalidade}/>

								<SecureDirectoryClientInformation solicitacao={solicitacao} onChangeProperties={this.onChangePropertiesSecureDirectoryClientInformation} readOnly={false} key={solicitacao.orgaoPossuiPastaSeguraConfigurada} />

								{ Number(solicitacao.situacao) === ID_SITUACAO_SOLICITACAO_REJEITADA_CEDENTE &&
									<div className="row">
										<div className="col-md">
											<div className="field">
												<div className="input">
													<label>Justificativa do cedente dos dados:</label>
													<textarea value={solicitacao.justificativaOrgaoFornecedor} readOnly={true} style={{height:"90px"}}/>
												</div>
											</div>
										</div>
									</div> 
								}

								{ Number(solicitacao.situacao) === ID_SITUACAO_SOLICITACAO_REJEITADA_GESTOR_PLATAFORMA &&
									<div className="row">
										<div className="col-md">
											<div className="field">
												<div className="input">
													<label>Justificativa conecta:</label>
													<textarea value={solicitacao.justificativaOrgaoAdministrador} readOnly={true} style={{height:"90px"}}/>
												</div>
											</div>
										</div>
									</div> 
								}

								{solicitacao.id && 
									<SolicitacaoAdesaoAttachmentsAndHistory solicitacao={solicitacao} habilitaEdicaoAnexo={true} keyHistory={this.state.dataHoraCarregamentoPagina}/>
								}

								{! solicitacao.id && 
									<div className="row">
										<div className="col-md">
											<span style={{color: '#C9302C'}}>
											* Os anexos ficarão disponíveis para download e upload após a inclusão da solicitação. 
											</span>
										</div>
									</div> 
								}
							</Fragment>
						}

						{/* button actions */}
						<div className="actions-button">
							<div className="actions justify-content-start">
								{this.state.solicitacao.alteracaoPermitida && 
									<button type="button" className="button is-primary" onClick={(e) => this.salvar(e, false)} disabled={!this.state.botoesHabilitados}>{solicitacao.id ? 'Alterar' : 'Incluir'}</button>
								}

								{solicitacao.liberacaoAssinaturaPermitida &&
									<button type="button" className="button is-secondary" 
										onClick={(e) => this.confirmaOperacao(this.salvar, [e, true], "Deseja realmente liberar a solicitação para assinatura?<br/><br/>Certifique-se de que o campo Finalidade está preenchido corretamente, seguindo as instruções disponíveis na seção de ajuda desse campo. Caso contrário, sua solicitação <b>poderá ser recusada</b>.")} 
										disabled={!this.state.botoesHabilitados}>Liberar para Assinatura</button>
								}	

								{this.state.solicitacao.assinaturaPermitida && 
									<Link to={`/solicitacao-adesao-arquivo-gv/sign/${solicitacao.id}`}>
										<button type="button" className="button is-secondary botaoNovo" onClick={this.assinar} disabled={!this.state.botoesHabilitados}>Assinar</button>
										</Link>
								}

								{this.state.solicitacao.id && 
									<button type="button" className="button is-secondary botaoNovo" onClick={this.novo} disabled={!this.state.botoesHabilitados}>Nova Solicitação</button>
								}

								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					</div>
				</div>
				
			);
		}

		validaFormulario(){
			let mensagens = [];
			const { solicitacao } = this.state;
			const { conjuntoArquivo, cpfDirigenteTi, cpfResponsavelTecnico, arquivos, finalidade, orgaoPossuiPastaSeguraConfigurada, ipsInternet, so } = solicitacao;

			if(!conjuntoArquivo){
				mensagens.push({mensagem: "Conjunto de Arquivo é obrigatório."})
			} else {

				if(!cpfDirigenteTi){
					mensagens.push({mensagem: "Dirigente de TI obrigatório."})
				}

				if(!cpfResponsavelTecnico){
					mensagens.push({mensagem: "Responsável técnico é obrigatório."})
				}

				if(!arquivos || arquivos.length === 0){
					mensagens.push({mensagem: "É necessário selecionar pelo menos um arquivo para adesão ou exclusão da adesão do órgão."})
				}

				if(!finalidade || finalidade.trim().length === 0 ){
					mensagens.push({mensagem: "Finalidade é obrigatória."})
				}

				if(!orgaoPossuiPastaSeguraConfigurada){
					if(!so || so.trim().length === 0 ){
						mensagens.push({mensagem: "Sistema Operacional da pasta segura é obrigatório."})
					}

					if(!ipsInternet || ipsInternet.length === 0 ){
						mensagens.push({mensagem: "IP's de Internet é obrigatório."})
					} else {
						const ips = ipsInternet.split(',').map(ip => ip.trim());
						const ipsInvalidos = ips.filter(ip => !isIP(ip));
						if(ipsInvalidos.length > 0){
							mensagens.push({mensagem: `Os seguintes IP's de Internet são inválidos: ${ipsInvalidos.join(', ')}.`})
						}
					}
				}

			}
		
			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		onChangePropertiesFinalidade(nome, valor){
			const solicitacao = this.state.solicitacao;
			solicitacao[nome] = valor;
			this.setState({ solicitacao, keyFinalidade: new Date() });
		}

		onChangePropertiesSecureDirectoryClientInformation(nome, valor){
			const solicitacao = this.state.solicitacao;
			solicitacao[nome] = valor;
			this.setState({ solicitacao });
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const solicitacao = this.state.solicitacao;
			solicitacao[nome] = valor;
			this.setState({ solicitacao });
		}

		handleOrgaoChange(evento){
			const orgao = evento.target.value;
			const { solicitacao }  = this.state;
			solicitacao.conjuntoArquivo = '';
			solicitacao.arquivos = [];
			solicitacao.finalidade = '';

			const arquivosDisponivesAdesao = [];

			this.setState({ solicitacao, orgao, tituloConjuntoArquivo: '', nomeOrgaoConjuntoArquivo: '', arquivosDisponivesAdesao });
			this.carregarConjuntosArquivosDisponiveisAdesao(orgao);
		}

		handleConjuntoArquivoChange(evento){
			const conjuntoArquivo = evento.target.value;
			const { solicitacao }  = this.state;
			solicitacao.conjuntoArquivo = conjuntoArquivo;
			solicitacao.finalidade = '';

			this.setState({ solicitacao });
			this.carregarArquivos(conjuntoArquivo);
			this.carregarInformacoesConjuntoArquivos(conjuntoArquivo);
		}

		carregaOrgaosFornecedoresArquivosGV() {
			this.setState({carregandoOrgaosFornecedores : true});
			api.get('/api/orgao/fornecedores-arquivo-gv')
				.then(response => { 
					this.setState({orgaos: response.data }) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os órgãos.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.setState({carregandoOrgaosFornecedores : false});
				});
		}

		carregarConjuntosArquivosDisponiveisAdesao(orgao) {
			let url = '/api/conjunto-arquivo-gv/disponivel-adesao-orgao';
			if(orgao) {	
				url += `?idOrgaoFornecedor=${orgao}`;
			}
			this.setState({carregandoConjuntosArquivos : true});
			api.get(url)
				.then(response => { 
					this.setState({conjuntosArquivos: response.data }) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os conjuntos de arquivos de grandes volumes.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.setState({carregandoConjuntosArquivos : false});
				});
		}

		carregarInformacoesConjuntoArquivos(conjuntoArquivo) {
			this.setState({tituloConjuntoArquivo: '', nomeOrgaoConjuntoArquivo: ''});
			if(conjuntoArquivo) {
				this.setState({carregandoDetalhesConjuntoArquivos: true});
				api.get(`/api/conjunto-arquivo-gv/${conjuntoArquivo}`)
					.then(response => { 
						const { solicitacao } = this.state;
						const conjuntoArquivo = response.data;
						solicitacao.tituloConjuntoArquivo = conjuntoArquivo.titulo;
						solicitacao.descricaoConjuntoArquivo = conjuntoArquivo.descricao;
						this.setState({solicitacao});
					})
					.catch(erro => {
						const msg = getMessagemErro("Não foi possível recuperar os detalhes do conjunto de arquivos.", erro);
						console.log(JSON.stringify(msg));
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					})
					.finally(()=> {
						this.setState({carregandoDetalhesConjuntoArquivos: false})
					});
			}
		}

		async carregarArquivos(conjuntoArquivo) {
			this.setState({arquivosOrgao: [], arquivosDisponivesAdesao: []});
			if(conjuntoArquivo) {

				this.setState({carregandoArquivos: true});
				const promisse1 =  api.get(`/api/arquivo-gv/conjunto-arquivo-gv/${conjuntoArquivo}?ativos=true`);
				const promisse2 = api.get(`/api/orgao/arquivos-gv-ativos/conjunto-arquivo-gv/${conjuntoArquivo}`);

				try {
						const responses = await Promise.all([promisse1, promisse2]);
						let arquivosDisponivesAdesao = responses[0].data;
						const arquivosOrgao = responses[1].data;
						const arquivosSolicitacao = this.state.solicitacao.arquivos;

						arquivosDisponivesAdesao = arquivosDisponivesAdesao.map(arquivo => {
							const orgaoPossuiAdesaoArquivo = arquivosOrgao.filter(arquivoOrgao => arquivoOrgao.id === arquivo.id).length > 0;
							const solicitacaoPossuiArquivo = arquivosSolicitacao.filter(arquivoSolicitacao => arquivoSolicitacao.id === arquivo.id).length > 0;
							
							const inclusao = !orgaoPossuiAdesaoArquivo && solicitacaoPossuiArquivo;
							const exclusao = orgaoPossuiAdesaoArquivo && solicitacaoPossuiArquivo;

							return {...arquivo, orgaoPossuiAdesaoArquivo, inclusao, exclusao};
						});

						this.setState({ arquivosDisponivesAdesao, arquivosOrgao });
					} catch (erro) {
						const msg = getMessagemErro("Não foi possível recuperar os arquivos", erro);
						console.log(JSON.stringify(msg));
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					}
					 finally {				
						this.setState({carregandoArquivos: false});
					}
				}
		}

		carregarDirigentesTi() {
			this.setState({
				carregandoDirigentesTi: true,
			});
			api.get('/api/gestor/dirigente-ti')
				.then(response => { 
					const dirigentesTi = response.data;
					const solicitacao = this.state.solicitacao;
					if (dirigentesTi.length === 1){
						solicitacao.cpfDirigenteTi = dirigentesTi[0].cpf
					}

					this.setState({dirigentesTi, solicitacao }) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os dirigentes de TI.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				}).finally(() => {
					this.setState({carregandoDirigentesTi : false});
				});
		}

		carregarResponsaveisTecnicos() {
			this.setState({
				carregandoResponsaveisTecnicos: true,
			});
			api.get('/api/gestor/responsavel-tecnico')
				.then(response => { 
					this.setState({responsaveisTecnicos: response.data }) 
					const responsaveisTecnicos = response.data;
					const solicitacao = this.state.solicitacao;
					if (responsaveisTecnicos.length === 1){
						solicitacao.cpfResponsavelTecnico = responsaveisTecnicos[0].cpf
					}

					this.setState({ responsaveisTecnicos, solicitacao })
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os responsáveis técnicos.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				}).finally(() => {
					this.setState({carregandoResponsaveisTecnicos : false});
				});
		}

		atualizaArquivoLista(arquivo, propriedade, valor) {
			const { solicitacao, arquivosDisponivesAdesao } = this.state;
			const arquivosAdesao = arquivosDisponivesAdesao.filter(a => a.id === arquivo.id);

			if (arquivosAdesao.length > 0) {
				arquivosAdesao[0][propriedade] = valor;
				if(valor){
					solicitacao.arquivos.push(arquivo);
				} else {
					const index = solicitacao.arquivos.findIndex(a => a.id === arquivo.id);
					if (index !== -1) {
						solicitacao.arquivos.splice(index, 1);
					}
				}
			}

			this.setState({ solicitacao, arquivosDisponivesAdesao });
		}

		adicionarAdesao(arquivo) {
			this.atualizaArquivoLista(arquivo, 'inclusao', true);
		}	

		desfazerAdesao(arquivo) {
			this.atualizaArquivoLista(arquivo, 'inclusao', false);
		}

		excluirAdesao(arquivo) {
			this.atualizaArquivoLista(arquivo, 'exclusao', true);
		}

		desfazerExclusao(arquivo) {	
			this.atualizaArquivoLista(arquivo, 'exclusao', false);
		}

		novo(e){
			const rotaParaNovo = "/solicitacao-adesao-arquivo-gv/new";
			if (rotaParaNovo === this.props.location.pathname) {
				this.props.history.push("/");
				this.props.history.goBack();
			} else {
				this.props.history.push(rotaParaNovo);
			}
		}

		confirmaOperacao(funcao, parametros, msgModal) {
			this.setState(
				{
					exibeModalConfirmacao: true,
					parametros,
					funcao,
					msgModal,
				}
			);
		}

		executaOperacao () {
			this.state.funcao.apply(this, this.state.parametros);
			this.setState({exibeModalConfirmacao : false});
		}

		salvar (e, liberarParaAssinatura){
			this.props.limpaMensagem();
			this.setState({exibeModalConfirmacao : false});

			const { solicitacao } = this.state;

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			const method = solicitacao.id ? 'put' : 'post';
			let url = '/api/solicitacao-adesao-arquivo-gv';
			if(solicitacao.id){
				url = url + '/' + solicitacao.id;
			}

			solicitacao.liberarParaAssinatura = liberarParaAssinatura;

			const options = {
				method,
				url,
				data: solicitacao
			}

			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});
			api(options)
				.then(response => { 
					let operacao = 'incluída';
					if(this.state.solicitacao.id) {
						if(liberarParaAssinatura) {
							operacao = 'liberada para assinatura';
						} else {
							operacao = 'alterada';
						}
					}
					const mensagem = `Solicitação de adesão ${operacao} com sucesso!`;
					const solicitacao = response.data;
			
					this.setState({ 
						solicitacao,
						dataHoraCarregamentoPagina: new Date(),
						keyFinalidade: new Date(),
					});
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = `Não foi possível ${this.state.solicitacao.id ? 'alterar' : 'incluir'} a solicitação de adesão.`;
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}
	
	}

) // redux
); // router